module.exports = __webpack_public_path__ + "static/media/logo-exp.44d471fa.jpg";